export class GeometryFiles {
  public id: number;
  public name: string;
  public description: string;
  public geometryId: number;
  public added: string;
  public companyId: number;
  public userId: number;
}
